<template>
  <b-modal id="changeemail-modal" ref="modal" title="Zmiana hasła" @hidden="onClose">
    <p>Zmień bieżące hasło do konta głównego:</p>
    <ValidationObserver
      ref="changeEmailForm"
      tag="form"
      @submit.prevent="onSubmit"
      id="changeEmailForm"
    >
      <div class="form-group row">
        <label for="Email" class="col-lg-4 col-form-label text-right">Aktualny Email:</label>
        <div class="col-lg-8">
          <input readonly disabled :value="user.email" class="form-control" type="email" />
        </div>
      </div>
      <div class="form-group row">
        <label for="email" class="col-lg-4 col-form-label text-right">Nowy Email:</label>
        <div class="col-lg-8">
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="validationContext"
            mode="lazy"
          >
            <b-form-input
              id="Email"
              v-model="form.email"
              type="email"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="changeEmailForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import userManager from "@/services/userManager.service";

export default {
  name: "ModalUserChangeEmail",
  props: {
    user: Object,
    prefix: { type: String, default: undefined }
  },
  data() {
    return {
      form: {
        email: ""
      }
    };
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onClose() {
      this.form.email = "";
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.changeEmailForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        userManager
          .changeEmail(this.user.id, this.form, this.prefix)
          .then(() => {
            this.user.email = this.form.email;
            this.$bvModal.hide("changeemail-modal");
          })
          .catch(error => {
            this.$refs.changeEmailForm.setErrors(error.response.data.fields);
          });
      });
    }
  }
};
</script>